import { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { ReactTableDataGrid } from "components/Table";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { formatterCreateAt } from "components/Function";

const limit = 10;

const ModalStatementTransactions = ({ isOpen, data, onClose, formatterCreateAt }) => {
    const [list, setList] = useState([]);
    const [listAll, setListAll] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        if (data) {
            setListAll(data);
            setList(data?.slice(0, limit) || []);
        }
    }, [data]);

    const columns = [
        {
            field: "_id",
            headerName: "",
            sort: true,
            editable: false,
            cellClass: "centered-cell",
            width: 10,
            cellRenderer: ({ rowIndex }) => rowIndex + 1,
        },
        {
            field: "type",
            headerName: t("Type"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "order_id",
            headerName: t("Order ID"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "adjustment_amount",
            headerName: t("Adjustment"),
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "fee_tax_amount",
            headerName: t("Fee Tax"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "revenue_amount",
            headerName: t("Revenue"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "shipping_cost_amount",
            headerName: t("Shipping Cost"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "settlement_amount",
            headerName: t("Settlement"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
        },
        {
            field: "order_create_time",
            headerName: t("Create Time"),
            cellClass: "centered-cell",
            editable: false,
            sort: true,
            flex: 1,
            cellRenderer: ({ value: cell, data: row, rowIndex }) => formatterCreateAt(+cell * 1000),
        },
    ];

    const onTableChanged = ({ page }) => {
        const startIndex = (page - 1) * limit;
        setList(listAll?.slice(startIndex, startIndex + limit) || []);
    };

    return (
        <Fragment>
            <Modal centered={true} fullscreen={true} toggle={onClose} isOpen={!!isOpen}>
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Transactions")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="al-variants-table al-max-height-table-cus">
                        <ReactTableDataGrid
                            idProperty="_id"
                            columns={columns}
                            height={350}
                            rowData={list}
                            gridOptions={{
                                reactiveCustomComponents: true,
                            }}
                            paginationPageSize={limit}
                            totalSize={data?.length || 0}
                            emptyText={"No data!"}
                            rowSelection="multiple"
                            onTableChanged={onTableChanged}
                            isSearchText={false}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Close")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    formatterCreateAt,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalStatementTransactions);
